import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { TextCallout2 } from 'blocket-ui'

const StoreName = styled(TextCallout2)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #696766;
  flex: 1;
  text-align: right;
`

const StoreInfo = ({ name }) => {
  if (!name) {
    return null
  }

  return <StoreName>{name}</StoreName>
}

StoreInfo.propTypes = {
  name: PropTypes.string,
}

export default StoreInfo
